import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
  getLanguageFromURL,
  isLanguageSupported,
} from "../utils/languageUtils";

/**
 * Custom hook to handle URL-based language detection and browser navigation
 */
export const useURLLanguage = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Handle initial URL language detection
    const handleInitialLanguage = () => {
      const urlLang = getLanguageFromURL();
      if (
        urlLang &&
        isLanguageSupported(urlLang) &&
        urlLang !== i18n.language
      ) {
        i18n.changeLanguage(urlLang);
      }
    };

    // Handle browser navigation (back/forward buttons)
    const handlePopState = () => {
      const urlLang = getLanguageFromURL();
      if (
        urlLang &&
        isLanguageSupported(urlLang) &&
        urlLang !== i18n.language
      ) {
        i18n.changeLanguage(urlLang);
      } else if (!urlLang && i18n.language !== "en") {
        // If no lang param and current language is not default, reset to default
        i18n.changeLanguage("en");
      }
    };

    // Initial check
    handleInitialLanguage();

    // Listen for browser navigation
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [i18n]);
};
